import Fetch from '../../Fetch/fetch';
import {useEngagementId} from '../../../../util/customHooks';
import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import * as AccountActions from '../../../../actions/Account/accountactions';
import {getHelixProject} from '../../../../actions/HelixIntegration/helixaction.js';
import HelixIntegrationModalContainer from '../../../Main/Ares/Helix/HelixIntegrationModal/index';
import HelixAccountDesignationTable from './HelixAccountDesignationTable';
import AccountSummaryTable from './AccountSummaryTable';
import MaterialityFetch from '../../../Common/Materiality/MaterialityFetch';

const AccountSummary = (props) => {
	const {documentId, body, isDisabled} = props;
	const dispatch = useDispatch();

	const engagementId = useEngagementId();

	const fetch = useCallback(
		() =>
			dispatch(
				AccountActions.getAccounts(engagementId, {
					orderBy: 'accountName',
					includeRelatedRisks: true,
					includePspIndexes: true,
					includeAssertions: true,
					includeHelix: true,
					includeRelatedDocuments: true
				})
			).then(() => dispatch(getHelixProject(engagementId))),
		[dispatch, engagementId]
	);
	return (
		<MaterialityFetch documentId={documentId}>
			<Fetch fetch={fetch}>
				<HelixIntegrationModalContainer>
					<HelixAccountDesignationTable renderGrid={AccountSummaryTable} body={body} isDisabled={isDisabled} />
				</HelixIntegrationModalContainer>
				{/*<AccountSummaryTableSignDis reloadSection={() => fetch} />*/}
			</Fetch>
		</MaterialityFetch>
	);
};

export default AccountSummary;
